import { useCallback, useMemo } from "react";
import { useTheme } from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import { Theme } from "@material-ui/core";
import { useAtomicStyles } from "styles";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useDispatch, useSelector } from "react-redux";
import { actions, selectors } from "redux-store";
import { useTypedTranslations } from "hooks";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    formContainer: {
      padding: "5% 10%",
    },
    formTitle: {
      fontWeight: "bold",
      fontSize: "25px",
      marginBottom: "0.4em",
    },
    inputField: {
      margin: "8px 0",
    },
    termsContainer: {
      margin: "1em 0 2em 0",
      fontSize: "11px",
    },
    member: {
      textAlign: "center",
      marginTop: "1em",
      fontSize: "12px",
    },
  }),
);

const schema = yup.object().shape({
  email: yup
    .string()
    .required("Inserisci la tua mail")
    .email("Inserisci una mail valida"),
  password: yup
    .string()
    .required("La password è obbligatoria")
    .min(8, "La password deve avere almeno 8 caratteri"),
  passwordConfirmation: yup
    .string()
    .oneOf([yup.ref("password")], "Le password non corrispondono"),
});

const fields = [
  {
    name: "email",
    type: "text",
    label: "Email",
  },
  {
    name: "password",
    type: "password",
    label: "Password",
  },
  {
    name: "passwordConfirmation",
    type: "password",
    label: "Conferma password",
  },
];

const useSignUpForm = () => {
  const theme = useTheme();
  const styles = useStyles(theme);
  const classes = useMemo(() => ({}), []);
  const atomicStyles = useAtomicStyles();
  const { register, handleSubmit, errors } = useForm<{
    email: string;
    password: string;
    passwordConfirmation: string;
  }>({
    resolver: yupResolver(schema),
  });
  const { register: register2, handleSubmit: handleSubmit2 } = useForm<{
    code: string;
  }>();
  const cognitoAuthStatus = useSelector(selectors.getCognitoAuthStatus);
  const signUpEmail = useSelector(selectors.getCognitoEmail);
  const signUpPassword = useSelector(selectors.getCognitoPassword);
  const [t] = useTypedTranslations();

  const dispatch = useDispatch();

  const onSubmit = useCallback(
    (data) => {
      dispatch(
        actions.cognitoSignUp({
          email: data.email,
          password: data.password,
        }),
      );
    },
    [dispatch],
  );

  const onVerificationCodeSubmit = useCallback(
    (data) => {
      dispatch(
        actions.cognitoConfirmSignUpCode({
          code: data.code,
          email: signUpEmail,
          password: signUpPassword,
        }),
      );
    },
    [dispatch, signUpEmail, signUpPassword],
  );

  return {
    styles,
    classes,
    atomicStyles,
    register,
    handleSubmit,
    onSubmit,
    errors,
    fields,
    cognitoAuthStatus,
    register2,
    handleSubmit2,
    onVerificationCodeSubmit,
    t,
  };
};

export { useSignUpForm as default };
